import axios from "@/utils/request";

const base_Url = "/bluetoothlight/web/";

// 管理员列表
const adminList = function() {
  return axios({
    method: "get",
    url: base_Url + `system/admins`
  });
};
// 管理员角色下拉列表
const roleSelect = function() {
  return axios({
    method: "get",
    url: base_Url + `system/roles/select`
  });
};
// 操作日志
const logs = function() {
  return axios({
    method: "get",
    url: base_Url + `system/logs`
  });
};
// 角色列表
const roleList = function(params) {
  return axios({
    method: "get",
    url: base_Url + `system/roles`,
    params
  });
};
// 角色详情
const roleDetail = function(params) {
  return axios({
    method: "get",
    url: base_Url + `system/roles/${params}`
  });
};
// 删除角色
const roledelete = function(params) {
  return axios({
    method: "delete",
    url: base_Url + `system/roles/${params}`,
    params
  });
};
//是否能删除角色
const canDelete = function (id) {
  return axios({
    method: 'get',
    url: base_Url + `system/roles/${id}/bound`
  })
}
export {
  adminList,
  roleSelect,
  logs,
  roleList,
  roleDetail,
  roledelete,
  canDelete
};
